import { render, staticRenderFns } from "./customer.list.vue?vue&type=template&id=33fbd3b6&scoped=true&"
import script from "./customer.list.vue?vue&type=script&lang=js&"
export * from "./customer.list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fbd3b6",
  null
  
)

export default component.exports